/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { formDetailsPageModels, SharedFormModelInterface } from 'cio/utils/forms';

interface FormsLinkToFormDetailsArgs {
  form?: SharedFormModelInterface;
}

export default class FormsLinkToFormDetails extends Component<FormsLinkToFormDetailsArgs> {
  get route() {
    let { form } = this.args;

    // fallback to linking to the forms list when form is not loaded:
    if (!form) {
      return 'integrations.forms';
    }

    return 'integrations.forms.form_details';
  }

  get models() {
    let { form } = this.args;

    if (!form) {
      return [];
    }

    return formDetailsPageModels(form);
  }
}
